import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ContactVIew from "@/views/ContactVIew.vue";
import IdView from "@/views/IdView.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import TermsConditions from "@/components/TermsConditions.vue";
import Shop from "@/components/Shop.vue";
import successpayment from "@/components/successPayment.vue";
import DashAdminVIew from "@/views/DashAdminVIew.vue";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import CRMPage from "../pages/Dashboard/CRMPage.vue";
import ProjectManagementPage from "../pages/Dashboard/ProjectManagementPage.vue";
import LMSPage from "../pages/Dashboard/LMSPage.vue";
import HelpDeskPage from "../pages/Dashboard/HelpDeskPage.vue";
import AnalyticsPage from "../pages/Dashboard/AnalyticsPage.vue";
import CryptoPage from "../pages/Dashboard/CryptoPage.vue";
import SalesPage from "../pages/Dashboard/SalesPage.vue";
import HospitalPage from "../pages/Dashboard/HospitalPage.vue";
import MarketingPage from "../pages/Dashboard/MarketingPage.vue";
import NFTPage from "../pages/Dashboard/NFTPage.vue";
import SaaSPage from "../pages/Dashboard/SaaSPage.vue";
import RealEstatePage from "../pages/Dashboard/RealEstatePage.vue";
import ShipmentPage from "../pages/Dashboard/ShipmentPage.vue";
// import FinancePage from "../pages/Dashboard/FinancePage.vue";
// import HomePage from "../pages/HomePage.vue";
// import FeaturesPage from "../pages/FeaturesPage.vue";
// import OurTeamPage from "../pages/OurTeamPage.vue";
// import FAQPage from "../pages/FAQPage.vue";
// import ContactPage from "../pages/ContactPage.vue";
// import CalendarPage from "../pages/Apps/CalendarPage.vue";
// import ToDoListPage from "../pages/Apps/ToDoListPage.vue";
// import ContactsPage from "../pages/Apps/ContactsPage.vue";
// import ChatPage from "../pages/Apps/ChatPage.vue";
// import InboxPage from "../pages/Apps/Email/InboxPage.vue";
// import ComposePage from "../pages/Apps/Email/ComposePage.vue";
// import ReadEmailPage from "../pages/Apps/Email/ReadEmailPage.vue";
// import SnoozedPage from "../pages/Apps/Email/SnoozedPage.vue";
// import DraftPage from "../pages/Apps/Email/DraftPage.vue";
// import SentMailPage from "../pages/Apps/Email/SentMailPage.vue";
// import TrashPage from "../pages/Apps/Email/TrashPage.vue";
// import SpamPage from "../pages/Apps/Email/SpamPage.vue";
// import StarredPage from "../pages/Apps/Email/StarredPage.vue";
// import ImportantPage from "../pages/Apps/Email/ImportantPage.vue";
// import KanbanBoardPage from "../pages/Apps/KanbanBoardPage.vue";
// import MyDrivePage from "../pages/Apps/FileManager/MyDrivePage.vue";
// import AssetsPage from "../pages/Apps/FileManager/AssetsPage.vue";
// import ProjectsPage from "../pages/Apps/FileManager/ProjectsPage.vue";
// import PersonalPage from "../pages/Apps/FileManager/PersonalPage.vue";
// import ApplicationsPage from "../pages/Apps/FileManager/ApplicationsPage.vue";
// import DocumentsPage from "../pages/Apps/FileManager/DocumentsPage.vue";
// import MediaPage from "../pages/Apps/FileManager/MediaPage.vue";
// import RecantsPage from "../pages/Apps/FileManager/RecantsPage.vue";
// import ImportantFilesPage from "../pages/Apps/FileManager/ImportantFilesPage.vue";
// import SpamFilesPage from "../pages/Apps/FileManager/SpamFilesPage.vue";
// import TrashFilesPage from "../pages/Apps/FileManager/TrashFilesPage.vue";
// import ProductsGridPage from "../pages/Ecommerce/ProductsGridPage.vue";
// import ProductsListPage from "../pages/Ecommerce/ProductsListPage.vue";
// import ProductDetailsPage from "../pages/Ecommerce/ProductDetailsPage.vue";
// import CreateProductPage from "../pages/Ecommerce/CreateProductPage.vue";
// import EditProductPage from "../pages/Ecommerce/EditProductPage.vue";
import CartPage from "../pages/Ecommerce/CartPage.vue";
// import CheckoutPage from "../pages/Ecommerce/CheckoutPage.vue";
// import OrdersPage from "../pages/Ecommerce/OrdersPage.vue";
// import OrderDetailsPage from "../pages/Ecommerce/OrderDetailsPage.vue";
// import CreateOrderPage from "../pages/Ecommerce/CreateOrderPage.vue";
// import OrderTrackingPage from "../pages/Ecommerce/OrderTrackingPage.vue";
// import CustomersPage from "../pages/Ecommerce/CustomersPage.vue";
// import CustomerDetailsPage from "../pages/Ecommerce/CustomerDetailsPage.vue";
// import CategoriesPage from "../pages/Ecommerce/CategoriesPage.vue";
// import SellersPage from "../pages/Ecommerce/SellersPage.vue";
// import SellerDetailsPage from "../pages/Ecommerce/SellerDetailsPage.vue";
// import CreateSellerPage from "../pages/Ecommerce/CreateSellerPage.vue";
// import ReviewsPage from "../pages/Ecommerce/ReviewsPage.vue";
// import RefundsPage from "../pages/Ecommerce/RefundsPage.vue";
// import CRMContactsPage from "../pages/CRM/CRMContactsPage.vue";
// import CRMCustomersPage from "../pages/CRM/CRMCustomersPage.vue";
// import LeadsPage from "../pages/CRM/LeadsPage.vue";
// import DealsPage from "../pages/CRM/DealsPage.vue";
// import ProjectOverviewPage from "../pages/ProjectManagement/ProjectOverviewPage.vue";
// import ProjectsListPage from "../pages/ProjectManagement/ProjectsListPage.vue";
// import CreateProjectPage from "../pages/ProjectManagement/CreateProjectPage.vue";
// import ClientsPage from "../pages/ProjectManagement/ClientsPage.vue";
// import TeamsPage from "../pages/ProjectManagement/TeamsPage.vue";
// import KanbanBoardsPage from "../pages/ProjectManagement/KanbanBoardsPage.vue";
// import UserPage from "../pages/ProjectManagement/UserPage.vue";
// import CoursesListPage from "../pages/LMS/CoursesListPage.vue";
// import CourseDetailsPage from "../pages/LMS/CourseDetailsPage.vue";
// import LessonPreviewPage from "../pages/LMS/LessonPreviewPage.vue";
// import CreateCoursePage from "../pages/LMS/CreateCoursePage.vue";
// import EditCoursePage from "../pages/LMS/EditCoursePage.vue";
// import InstructorsPage from "../pages/LMS/InstructorsPage.vue";
// import TicketsPage from "../pages/HelpDesk/TicketsPage.vue";
// import TicketDetailsPage from "../pages/HelpDesk/TicketDetailsPage.vue";
// import AgentsPage from "../pages/HelpDesk/AgentsPage.vue";
// import ReportsPage from "../pages/HelpDesk/ReportsPage.vue";
// import MarketplacePage from "../pages/NFTMarketplace/MarketplacePage.vue";
// import ExploreAllPage from "../pages/NFTMarketplace/ExploreAllPage.vue";
// import LiveAuctionPage from "../pages/NFTMarketplace/LiveAuctionPage.vue";
// import NFTDetailsPage from "../pages/NFTMarketplace/NFTDetailsPage.vue";
// import CreatorsPage from "../pages/NFTMarketplace/CreatorsPage.vue";
// import CreatorDetailsPage from "../pages/NFTMarketplace/CreatorDetailsPage.vue";
// import WalletConnectPage from "../pages/NFTMarketplace/WalletConnectPage.vue";
// import RealEstateCustomersPage from "../pages/RealEstate/RealEstateCustomersPage.vue";
// import PropertyListPage from "../pages/RealEstate/PropertyListPage.vue";
// import PropertyOverviewPage from "../pages/RealEstate/PropertyOverviewPage.vue";
// import AddPropertyPage from "../pages/RealEstate/AddPropertyPage.vue";
// import AgentlistPage from "../pages/RealEstate/AgentlistPage.vue";
// import AgentOverviewPage from "../pages/RealEstate/AgentOverviewPage.vue";
// import AddAgentPage from "../pages/RealEstate/AddAgentPage.vue";
// import WalletPage from "../pages/Finance/WalletPage.vue";
// import TransactionPage from "../pages/Finance/TransactionPage.vue";
// import EventsPage from "../pages/Events/EventsPage.vue";
// import EventsListPage from "../pages/Events/EventsListPage.vue";
// import EventDetailsPage from "../pages/Events/EventDetailsPage.vue";
// import CreateAnEventPage from "../pages/Events/CreateAnEventPage.vue";
// import EditAnEventPage from "../pages/Events/EditAnEventPage.vue";
// import ProfilePage from "../pages/Social/ProfilePage.vue";
// import SettingsPage from "../pages/Social/SettingsPage.vue";
// import InvoicesPage from "../pages/Invoices/InvoicesPage.vue";
// import InvoiceDetailsPage from "../pages/Invoices/InvoiceDetailsPage.vue";
// import CreateInvoicePage from "../pages/Invoices/CreateInvoicePage.vue";
// import EditInvoicePage from "../pages/Invoices/EditInvoicePage.vue";
// import TeamMembersPage from "../pages/Users/TeamMembersPage.vue";
// import UsersListPage from "../pages/Users/UsersListPage.vue";
// import AddUserPage from "../pages/Users/AddUserPage.vue";
// import UserProfilePage from "../pages/Profile/UserProfilePage.vue";
// import UserTeamPage from "../pages/Profile/UserTeamPage.vue";
// import UserProjectsPage from "../pages/Profile/UserProjectsPage.vue";
// import StarterPage from "../pages/StarterPage.vue";
// import MaterialSymbolsPage from "../pages/Icons/MaterialSymbolsPage.vue";
// import FeatherIconPage from "../pages/Icons/FeatherIconPage.vue";
// import RemixIconPage from "../pages/Icons/RemixIconPage.vue";
// import AlertsPage from "../pages/UIElements/AlertsPage.vue";
// import AvatarPage from "../pages/UIElements/AvatarPage.vue";
// import ButtonsPage from "../pages/UIElements/ButtonsPage.vue";
// import BadgesPage from "../pages/UIElements/BadgesPage.vue";
// import CardsPage from "../pages/UIElements/CardsPage.vue";
// import CarouselsPage from "../pages/UIElements/CarouselsPage.vue";
// import DropdownsPage from "../pages/UIElements/DropdownsPage.vue";
// import GridsPage from "../pages/UIElements/GridsPage.vue";
// import ImagesPage from "../pages/UIElements/ImagesPage.vue";
// import ListPage from "../pages/UIElements/ListPage.vue";
// import ModalsPage from "../pages/UIElements/ModalsPage.vue";
// import NavsPage from "../pages/UIElements/NavsPage.vue";
// import PaginationsPage from "../pages/UIElements/PaginationsPage.vue";
// import PopoverTooltipsPage from "../pages/UIElements/PopoverTooltipsPage.vue";
// import ProgressPage from "../pages/UIElements/ProgressPage.vue";
// import SpinnersPage from "../pages/UIElements/SpinnersPage.vue";
// import TabsPage from "../pages/UIElements/TabsPage.vue";
// import AccordionsPage from "../pages/UIElements/AccordionsPage.vue";
// import DateTimePickerPage from "../pages/UIElements/DateTimePickerPage.vue";
// import VideosPage from "../pages/UIElements/VideosPage.vue";
// import BasicTablePage from "../pages/Tables/BasicTablePage.vue";
// import DataTablePage from "../pages/Tables/DataTablePage.vue";
// import BasicElementsPage from "../pages/Forms/BasicElementsPage.vue";
// import AdvancedElementsPage from "../pages/Forms/AdvancedElementsPage.vue";
// import ValidationPage from "../pages/Forms/ValidationPage.vue";
// import WizardPage from "../pages/Forms/WizardPage.vue";
// import EditorsPage from "../pages/Forms/EditorsPage.vue";
// import FileUploadPage from "../pages/Forms/FileUploadPage.vue";
// import ApexChartsPage from "../pages/ApexChartsPage.vue";
import OTP from "@/components/Modules/Authentication/OTP/index.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import ForgetPasswordPage from "../pages/Authentication/ForgetPasswordPage.vue";
import LockScreenPage from "../pages/Authentication/LockScreenPage.vue";
import LogOutPage from "../pages/Authentication/LogOutPage.vue";
import ConfirmMailPage from "../pages/Authentication/ConfirmMailPage.vue";

// import InternalErrorPage from "../pages/Error/InternalErrorPage.vue";
// import ErrorPage from "../pages/ErrorPage.vue";
// import WidgetsPage from "../pages/WidgetsPage.vue";
// import GoogleMapPage from "../pages/GoogleMapPage.vue";

import NotificationPage from "../pages/NotificationPage.vue";
import MemberPage from "../pages/MemberPage.vue";
import MyProfilePage from "../pages/MyProfilePage.vue";

import AccountSettingsPage from "../pages/Settings/AccountSettingsPage.vue";
import ChangePasswordPage from "../pages/Settings/ChangePasswordPage.vue";
import ConnectionsPage from "../pages/Settings/ConnectionsPage.vue";
import PrivacyPolicyPage from "../pages/Settings/PrivacyPolicyPage.vue";
import TermsConditionsPage from "../pages/Settings/TermsConditionsPage.vue";
import ClassDetails from "@/components/Apps/ClassDetails/classDetails.vue";
import PromoteClass from "@/components/Apps/ClassDetails/promoteClass.vue";
import SchoolDetails from "@/components/Apps/SchoolDetails/schoolDetails.vue";
import UserList from "@/components/Apps/AddUser/UserList.vue";
import recoveryStudent from "@/components/Apps/RecoveryStudentsList/index.vue";
// import AddUser from "@/components/Apps/AddUser/addUser.vue";
// import StudentList from "@/components/Apps/ClassDetails/StudentList.vue";
import StudentListNewTable from "@/components/Apps/ClassDetails/StudentListNewTable.vue";
import ArrangePhotoTemplate from "@/components/Apps/ClassDetails/ArrangePhotoTemplate.vue";
import StudentDetail from "@/components/Apps/ClassDetails/studentDetail.vue";
import uploadFile from "@/components/Apps/UploadFile/uploadFile.vue";
import EditStudent from "@/components/Apps/ClassDetails/EditStudent.vue";
import cardSample from "@/components/Apps/cardSample/cardSample.vue";
import LandingCard from "@/components/Apps/cardSample/LandingCard.vue";
import PrintIDCardPage from "@/components/Apps/cardSample/PrintIDCardPage.vue";
//import ProgressComponent from "@/components/Apps/ProgressTrackers/progressComponent.vue";
//import PersonalInfo from "@/components/Apps/ProgressTrackers/PersonalInfo.vue";
//import Review from "@/components/Apps/ProgressTrackers/Review.vue";
//import Submit from "@/components/Apps/ProgressTrackers/Submit.vue";
//import SchoolDetailSTEP from "@/components/Apps/ProgressTrackers/SchoolDetail.vue";
// import CardsPage from "@/pages/UIElements/CardsPage.vue";
import StepForm from "@/components/Apps/Steps/StepForm.vue";
import EmployeeList from "../components/Apps/Employee/EmployeeList.vue";
import UploadFileEmployee from "@/components/Apps/UploadFile/uploadFileEmployee.vue";
import UpdateStudent from "@/components/Apps/ClassDetails/UpdateStudent.vue";
import ServiceIndividualsView from "@/views/ServiceIndividualsView.vue";
import CartView from "@/views/CartView.vue";
import ProfileDetail from "@/components/Others/MyProfile/ProfileDetail.vue";
import AccountSecurity from "@/components/Others/MyProfile/AccountSecurity.vue";
import Image from "@/components/Others/MyProfile/Image.vue";
import Support from "@/components/Layouts/TopHeader/support.vue";
import Images from "@/components/Apps/UploadFile/Image.vue";
import RollImages from "@/components/Apps/UploadFile/ImageOld.vue";
import OptionButton from "@/components/Apps/UploadFile/OptionButton.vue";
import CartForm from "@/components/CartForm.vue";
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
  routes: [
    {
      path: "/cardSample",
      name: "CardsPage",
      component: cardSample,
      meta: { requiresAuth: true },
    },
    {
      path: "/generate-id-card",
      name: "generate-id-card",
      component: LandingCard,
      meta: { requiresAuth: true },
    },
    {
      path: "/print-id-card",
      name: "PrintIDCard",
      component: PrintIDCardPage,
      meta: { requiresAuth: true },
    },
    // {
    //   path: "/KanbanBoardPage",
    //   name: "KanbanBoardPage",
    //   component: KanbanBoardPage,
    // },
    {
      path: "/StepForm",
      name: "StepForm",
      component: StepForm,
    },
    {
      path: "/dashboard",
      name: "admin",
      component: DashAdminVIew,
      meta: { requiresAuth: true },
    },
    // {
    //   path: "/ecommerce/product-details",
    //   name: "ProductDetailsPage",
    //   component: ProductDetailsPage,
    // },

    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/service",
      name: "service",
      component: ServiceView,
    },
    {
      path: "/serviceProduct/:id",
      name: "serviceProduct",
      component: ServiceIndividualsView,
    },
    {
      path: "/product/:id",
      name: "id-card",
      component: IdView,
      props: true,
    },

    {
      path: "/contact",
      name: "contact",
      component: ContactVIew,
    },
    {
      path: "/cart",
      name: "cart",
      component: CartView,
    },
    {
      path: "/checkout",
      name: "checkout",
      component: CartForm,
    },

    {
      path: "/payment",
      name: "Shop",
      component: Shop,
    },
    {
      path: "/order-success",
      name: "successpayment",
      component: successpayment,
    },

    {
      path: "/school-detail/",
      name: "SchoolDetail",
      component: SchoolDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/class-info/",
      name: "class-detail",
      component: ClassDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/promote-class/",
      name: "promote-class",
      component: PromoteClass,
      meta: { requiresAuth: true },
    },
    {
      path: "/archived_student/",
      name: "archived_student",
      component: recoveryStudent,
      meta: { requiresAuth: true },
    },
    {
      path: "/employeeDetail/",
      name: "employee",
      component: EmployeeList,
      meta: { requiresAuth: true },
    },

    {
      path: "/terms-and-conditions",
      name: "terms",
      component: TermsConditions,
    },
    {
      path: "/privacy-policy",
      name: "privacy",
      component: PrivacyPolicy,
    },
    {
      path: "/class-info/",
      name: "class-detail",
      component: ClassDetails,
      meta: { requiresAuth: true },
    },

    {
      path: "/user-list",
      name: "user_list",
      component: UserList,
      meta: { requiresAuth: true },
    },

    // {
    //   path: "/students/:id",
    //   name: "StudentList",
    //   component: StudentList,
    //   props: true,
    // },
    {
      path: "/students/:id",
      name: "StudentList",
      component: StudentListNewTable,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/edit-student/:studentId",
      name: "EditStudent",
      component: EditStudent,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/update-student/:studentId",
      name: "UpdateStudent",
      component: UpdateStudent,
      props: true, // Enable passing the studentId as a prop
      meta: { requiresAuth: true },
    },
    {
      path: "/student-detail/:studentId/:classId",
      name: "StudentDetail",
      component: StudentDetail,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/uploadFile",
      name: "OptionButton",
      component: OptionButton,
      meta: { requiresAuth: true },
    },
    {
      path: "/uploadFile/drag&drop",
      name: "uploadImage",
      component: Images,
      meta: { requiresAuth: true },
    },
    {
      path: "/uploadFile/roll",
      name: "uploadImages",
      component: RollImages,
      meta: { requiresAuth: true },
    },
    {
      path: "/uploadFile/student",
      name: "uploadFile",
      component: uploadFile,
      meta: { requiresAuth: true },
    },
    {
      path: "/uploadFile/employee",
      name: "UploadFileEmployee",
      component: UploadFileEmployee,
      meta: { requiresAuth: true },
    },
    {
      path: "/arrange-photo",
      name: "ArrangePhoto",
      component: ArrangePhotoTemplate,
      meta: { requiresAuth: true },
    },

    // {
    //   path: "/social/profile",
    //   name: "ProfilePage",
    //   component: ProfilePage,
    // },
    // {
    //   path: "/social/settings",
    //   name: "SettingsPage",
    //   component: SettingsPage,
    // },
    // {
    //   path: "/users/add-user",
    //   name: "AddUserPage",
    //   component: AddUserPage,
    // },
    {
      path: "/authentication/otp",
      name: "OTP",
      component: OTP,
    },
    {
      path: "/authentication/login",
      name: "LoginPage",
      component: LoginPage,
    },
    {
      path: "/authentication/register",
      name: "RegisterPage",
      component: RegisterPage,
    },
    {
      path: "/authentication/reset-password",
      name: "ResetPasswordPage",
      component: ResetPasswordPage,
    },
    {
      path: "/authentication/forget-password",
      name: "ForgetPasswordPage",
      component: ForgetPasswordPage,
    },
    {
      path: "/authentication/lock-screen",
      name: "LockScreenPage",
      component: LockScreenPage,
    },
    {
      path: "/authentication/logout",
      name: "LogOutPage",
      component: LogOutPage,
    },
    {
      path: "/authentication/confirm-mail",
      name: "ConfirmMailPage",
      component: ConfirmMailPage,
    },
    {
      path: "/notification",
      name: "NotificationPage",
      component: NotificationPage,
    },
    {
      path: "/my-profile",
      name: "MyProfilePage",
      component: MyProfilePage,
    },
    {
      path: "/support",
      name: "support",
      component: Support,
    },
    {
      path: "/goToAccount",
      name: "goToAccount",
      component: MyProfilePage,
    },
    {
      path: "/goToAccountSecurity",
      name: "goToAccountSecurity",
      component: AccountSecurity,
    },
    {
      path: "/goToImages",
      name: "goToImages",
      component: Image,
    },
    {
      path: "/settings/account-settings",
      name: "AccountSettingsPage",
      component: AccountSettingsPage,
    },
    {
      path: "/settings/change-password",
      name: "ChangePasswordPage",
      component: ChangePasswordPage,
    },
    {
      path: "/settings/connections",
      name: "ConnectionsPage",
      component: ConnectionsPage,
    },
    {
      path: "/settings/privacy-policy",
      name: "PrivacyPolicyPage",
      component: PrivacyPolicyPage,
    },
    {
      path: "/settings/terms-conditions",
      name: "TermsConditionsPage",
      component: TermsConditionsPage,
    },
    // { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
  ],
});

// Navigation guard to check for authentication before accessing protected routes
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("accessToken"); // Check if user is authenticated
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth); // Check if the route requires authentication

  if (requiresAuth && !isAuthenticated) {
    // If the route requires authentication and the user is not authenticated, redirect to login
    next("/authentication/login");
  } else {
    next(); // Allow access to the route
  }
});
export default router;
